import React, {useEffect} from 'react';
import './DetailDocumentIssuance.scss';
import DynaButton from "../../../DynaView/DynaButton";
import {useNavigate} from "react-router-dom";
import SubmitDataHandler from "../SubmitDataHandler";

const RowSubmitDocumentIssuance = ({sendData, setSendData}) => {

  const navigateTo = useNavigate();

  const submitDataHandler = () => {
    void SubmitDataHandler(sendData, setSendData, navigateTo)
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        void SubmitDataHandler(sendData, setSendData, navigateTo)
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [sendData]);

  return (
    <div className={"RowSubmitDocumentIssuance"}>
      <div className={"button-side"}>
        <DynaButton className={"simple-but"}
                    type={"button"}
                    onClick={submitDataHandler}>ثبت</DynaButton>
        <DynaButton className={"simple-but-no-bac"}
                    type={"button"}
                    onClick={() => navigateTo(-1)}>انصراف</DynaButton>
      </div>
      <div className={"inline-short-cut"}>
        <h6>ثبت نهایی : F2</h6>
        <h6>بارگزاری فایل : ctrl + o</h6>
        <h6>ذخیره فایل : ctrl + s</h6>
        <h6>چاپ جدول : ctrl + p</h6>
        <h6>افزودن 3 صفر : + </h6>
        <h6>کاهش 3 صفر : --</h6>
        <h6>ورود مبلغ تراز : space </h6>
      </div>
    </div>
  );
};

export default RowSubmitDocumentIssuance;